import { useState } from 'react';
import {
  Icon,
  Button,
  TableRow,
  TableCell,
  Typography,
} from '@safedns/skydns-ui-react-lib';

import sprite from '../../icons/sprite.svg';
import UpdateAgentModal from './UpdateAgentModal';
import DeleteAgentModal from './DeleteAgentModal';

import { actionTableCellStyle } from '../../styles/tableStyles';

import { formatDate } from '../../utils/formatDate.js';

/**
 *
 * @param {string} uid
 * @param {string} device
 * @param {string} comment
 * @param {number} profile
 * @param {string} os
 * @param {string} lastSeen
 * @returns
 */

const cellStyles = {
  paddingLeft: 0,
};

const AgentsTableRow = ({ uid, device, comment, profile, os, lastSeen }) => {
  const [isUpdateAgentModalShow, setUpdateAgentModalState] = useState(false);
  const [isDeleteAgentModalShow, setDeleteAgentModalState] = useState(false);

  const updateAgentModalStateHandler = () => {
    setUpdateAgentModalState((prevState) => !prevState);
  };

  const deleteAgentModalStateHandler = () => {
    setDeleteAgentModalState((prevState) => !prevState);
  };

  return (
    <>
      <TableRow>
        <TableCell sx={{ pr: 0 }}>
          <Typography variant="body1">{device}</Typography>
          <Typography variant="caption">{comment}</Typography>
        </TableCell>
        <TableCell sx={cellStyles}>{profile}</TableCell>
        <TableCell sx={cellStyles}>
          <Typography variant="body1" component="span">
            {os}
          </Typography>
        </TableCell>
        <TableCell sx={cellStyles}>
          <Typography
            variant="body1"
            component="span"
            sx={{
              fontSize: '14px',
              fontWeight: 600,
              color: 'secondary.contrastText',
            }}
          >
            {formatDate(lastSeen)}
          </Typography>
        </TableCell>
        <TableCell sx={actionTableCellStyle}>
          <Button
            variant="icon"
            isIconButton
            onClick={updateAgentModalStateHandler}
          >
            <Icon id="edit" sprite={sprite} width={22} height={22} />
          </Button>
        </TableCell>
        <TableCell sx={actionTableCellStyle}>
          <Button
            variant="icon"
            isIconButton
            onClick={deleteAgentModalStateHandler}
          >
            <Icon id="remove" sprite={sprite} width={22} height={22} />
          </Button>
        </TableCell>
      </TableRow>
      {isUpdateAgentModalShow ? (
        <UpdateAgentModal
          uid={uid}
          comment={comment}
          onClose={updateAgentModalStateHandler}
        />
      ) : null}
      {isDeleteAgentModalShow ? (
        <DeleteAgentModal
          uid={uid}
          agentName={device}
          onClose={deleteAgentModalStateHandler}
        />
      ) : null}
    </>
  );
};

export default AgentsTableRow;
